import React from "react";

import { TableStyled } from "./styles/Table.styled";

const Table: React.FC = ({ children }) => {
    return <TableStyled hover>{children}</TableStyled>;
};

export default Table;
